module.exports = __webpack_public_path__ + "media/newstyle/images/logo-google-color-833de066a92e40bf8be49bc07d34d863.png";